import React from 'react';

const Section = ({ children, ...props }) => (
  <section {...props}>{React.Children.toArray(children)}</section>
);

export default Section;
